export var isNodeOrNull = function isNodeOrNull(value) {
  return null === value || value instanceof Node;
};